export const ItLocationOptions = ({placeholder = 'All locations'}) => {
  const locations = useItLocations().sort((a, b) => a.name.localeCompare(b.name))

  return pug`
    option(value='')= placeholder
    for location in locations
      option(key=location.id value=location.id)= location.name
  `
}
